import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { GasTags } from '../gas-tags.namespace';

@Component({
  selector: 'gas-tags',
  templateUrl: './gas-tags.component.html',
  styleUrls: ['./gas-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasTagsComponent {

  @Input()
  public label = '';

  @Input()
  public actionLabel = '';

  @Input()
  public tags: GasTags.GasTag<unknown>[];

  @Output('itemClicked')
  public itemClicked$ = new EventEmitter<unknown>();

  @Output('actionLabelClicked')
  public actionLabelClicked$ = new EventEmitter<void>();

  public emitClickOnItem(tagValue: unknown): void {
    this.itemClicked$.emit(tagValue);
  }

  public emitClickOnActionLabel(): void {
    this.actionLabelClicked$.emit();
  }
}
